<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const fetchBlockad = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { q?: string } = {};

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("operation/blockad/fetchBlockad", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["operation/blockad/blockadSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            flashWarning("Kunde inte hämta blockad");
        }
    };
</script>

<template>
    <KAutocomplete
        name="blockad"
        label="Blockad"
        v-bind="$attrs"
        :options="fetchBlockad"
        :converter="defaultAutocompleteConverter"
    />
</template>

<style lang="scss" scoped></style>
